import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class Duplicate extends Icon {
  render() {
    let { color, size, style, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        style={style}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
      >
        <g fill={color}>
          <path d="M15.2,2.8H3.6L2.8,3.6v11.7L3.6,16h11.7l0.8-0.8V3.6L15.2,2.8z M14.5,14.5H4.3V4.3h10.1V14.5z" />
          <polygon points="12.4,0 0.8,0 0,0.8 0,12.4 1.5,12.4 1.5,1.5 12.4,1.5  " />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/Duplicate.js